import { Controller, useFormContext } from "react-hook-form";

import { FieldErrors } from "src/api/types";
import { Card } from "src/base-components/Card";
import { AutocompleteCodeInput } from "src/base-components/CodeInput/EditorCodeInput";
import { CustomTitle } from "src/entityActionNodes/LocateEntityCard";
import { ReadEntityNodeForm } from "src/entityActionNodes/ReadEntityNodeEditor";
import { useIsFieldHighlighted } from "src/flowGraph/canvasSearch/CanvasSearchHighlightContext";

export const OutputLocationCard = ({
  immutable,
  fieldErrors,
}: {
  immutable: boolean;
  fieldErrors: FieldErrors;
}) => {
  const formMethods = useFormContext<ReadEntityNodeForm>();
  const outputDestinationFieldId = formMethods.getValues(
    "output_destination_expression.id",
  );
  const outputDestinationError = fieldErrors[outputDestinationFieldId];
  const isSearchHighlighted = useIsFieldHighlighted(outputDestinationFieldId);
  return (
    <Card>
      <Card.Header>
        <CustomTitle
          description="Choose the flow-data field to store the fetched Entity. The output will match the selected Entity type."
          title="Set output location"
          required
        />
      </Card.Header>
      <Card.Content>
        <Controller
          control={formMethods.control}
          name="output_destination_expression.value"
          render={({ field }) => (
            <AutocompleteCodeInput
              dataLoc="output-destination-expression"
              disabled={immutable}
              error={outputDestinationError}
              isSearchHighlighted={isSearchHighlighted}
              placeholder="field"
              prefix="data."
              value={field.value}
              onChange={field.onChange}
            />
          )}
        />
      </Card.Content>
    </Card>
  );
};
